import { render, staticRenderFns } from "./EmailTextAreaCopy.vue?vue&type=template&id=6e2e3150&scoped=true&"
import script from "./EmailTextAreaCopy.vue?vue&type=script&lang=ts&"
export * from "./EmailTextAreaCopy.vue?vue&type=script&lang=ts&"
import style0 from "./EmailTextAreaCopy.vue?vue&type=style&index=0&id=6e2e3150&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e2e3150",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VIcon})
